import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getActiveTabFromPath } from "web_myplann/Shared/Header/getActiveTab";
import { useIsNavbarRoot } from "web_myplann/Shared/Hooks/useIsNavbarRoot";
import { useRouteHandleFlag } from "web_myplann/Shared/Hooks/useRouteHandleFlag";
import { navbarSuppressionCountAtom } from "web_myplann/Shared/State/navbarSuppressionAtom";
import { device } from "web_myplann/Utils/device";

export const RouteNativeSync = () => {
	const isNavbarRoot = useIsNavbarRoot();
	const suppressionCount = useAtomValue(navbarSuppressionCountAtom);
	const showNavbar = isNavbarRoot && suppressionCount === 0;

	const isStatusBarOverlayRoute = useRouteHandleFlag("statusBarOverlay");

	const { pathname } = useLocation();
	const activeTab = getActiveTabFromPath(pathname);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	useEffect(() => {
		device.showNavbar(showNavbar).catch(() => {});
	}, [showNavbar]);

	useEffect(() => {
		device.setActiveTab(activeTab).catch(() => {});
	}, [activeTab]);

	useEffect(() => {
		if (!isStatusBarOverlayRoute) {
			device.setStatusBarOverlay(false).catch(() => {});
		}
	}, [isStatusBarOverlayRoute]);

	return <Outlet />;
};
